<template>
  <el-dialog top="8vh" :append-to-body="true" :visible.sync="dialogVisible" :width="dialogWidth" :show-close="false" :close-on-click-modal="false" custom-class="result-dialog" @close="handleClose">
    <div class="result-modal">
      <!-- 图标 -->
      <div class="result-icon-wrap">
        <img v-if="iconSrc" :src="iconSrc" class="result-icon-img" />
        <div v-else class="result-icon-check">
          <span class="check-mark"></span>
        </div>
      </div>

      <!-- 标题 -->
      <h3 class="result-title">{{ title }}</h3>

      <!-- 副标题 -->
      <div class="result-subtitle">{{ subtitle }}</div>

      <!-- 插槽区域 -->
      <div class="result-slot">
        <slot></slot>
      </div>

      <!-- 按钮区域 -->
      <div class="result-btns" :style="{ marginTop: btnMarginTop }">
        <button v-if="showCancel" class="result-btn result-btn-cancel" @click="handleCancel">{{ cancelText }}</button>
        <button v-if="showConfirm" class="result-btn result-btn-confirm" @click="handleConfirm">{{ confirmText }}</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ResultDialog",
  props: {
    /** 弹窗是否可见 */
    visible: {
      type: Boolean,
      default: false,
    },
    /** 主标题 */
    title: {
      type: String,
      default: "提交成功",
    },
    /** 副标题 */
    subtitle: {
      type: String,
      default: "请耐心等待采购方确认验样结果",
    },
    /** 取消按钮文字 */
    cancelText: {
      type: String,
      default: "取消",
    },
    /** 确定按钮文字 */
    confirmText: {
      type: String,
      default: "确定",
    },
    /** 自定义图标 src，不传则使用默认绿色对勾 */
    iconSrc: {
      type: String,
      default: "",
    },
    /** 是否显示取消按钮 */
    showCancel: {
      type: Boolean,
      default: true,
    },
    /** 是否显示确定按钮 */
    showConfirm: {
      type: Boolean,
      default: true,
    },
    /** 弹窗宽度 */
    dialogWidth: {
      type: String,
      default: "420px",
    },
    /** 按钮区域上边距 */
    btnMarginTop: {
      type: String,
      default: "76px",
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      this.$emit("confirm");
    },
    handleClose() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style>
/* ===== 弹窗全局样式（非 scoped，因 el-dialog append-to-body） ===== */
.result-dialog {
  border-radius: 30px;
}

.result-dialog .el-dialog__header {
  padding: 0;
  display: none;
}

.result-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.result-modal {
  position: relative;
  padding: 48px 0 30px 0;
  text-align: center;
  background-color: #fff;
  border-radius: 30px;
}

/* 图标区域 */
.result-icon-wrap {
  margin: 0 auto 15px auto;
}

.result-icon-img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

/* 默认绿色对勾图标 */
.result-icon-check {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #00a63e;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-mark {
  display: block;
  width: 14px;
  height: 24px;
  border: solid #ffffff;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
  margin-top: -3px;
  border-radius: 2px;
}

/* 标题 */
.result-title {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 24px;
  color: #333333;
  margin: 0 auto;
  line-height: normal;
}

/* 副标题 */
.result-subtitle {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  padding: 0 40px;
  margin-top: 6px;
}

/* 插槽区域 */
.result-slot {
  width: 420px;
  border-radius: 30px;
  margin: 20px auto 0 auto;
}

/* 按钮区域 */
.result-btns {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.result-btn {
  width: 160px;
  height: 48px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  transition: opacity 0.2s;
}

.result-btn:hover {
  opacity: 0.9;
}

.result-btn:active {
  opacity: 0.85;
}

.result-btn-cancel {
  background: #e2e2e2;
  color: #333333;
}

.result-btn-confirm {
  background: #1869ff;
  color: #ffffff;
}
</style>
